// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { str } from '@lit/localize';
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    s061cc20e3432dead: `🇪🇸Pause`,
    s086eac065e0de798: `🇪🇸Warning icon`,
    s08fe3407b5984795: `🇪🇸DD`,
    s09167707b5ad4b4f: `🇪🇸MM`,
    s0a1461c7d10083f2: `🇪🇸Show previous tab`,
    s0b712a3d9e6a8b51: `🇪🇸Success icon`,
    s13f20cb257e12fac: `🇪🇸This field is required`,
    s188816d451d28ecc: `🇪🇸Previous button`,
    s1a591f00304f397e: `🇪🇸Show next tab`,
    s1c8831f1077e3f4b: `🇪🇸Clear password field`,
    s1fb7398a681450c4: str `🇪🇸Please select checkbox.`,
    s28a2d295841441c7: str ` 🇪🇸 ${0} characters remaining`,
    s2b49a024a4b02579: str ` 🇪🇸 ${0} characters too long`,
    s2c7649cda64be0dc: `🇪🇸more info`,
    s2ed378797ea227ae: `🇪🇸Error check icon`,
    s2f7f35f6a5b733f5: `🇪🇸Show password`,
    s452f791e0ff6a13e: `🇪🇸Hide password`,
    s593bc11085c7159f: `🇪🇸Arrow icon`,
    s5d277c8dbc8d5ebf: str `🇪🇸 1 character remaining`,
    s6fbf813ddff28320: str `🇪🇸Select a date starting from ${0}`,
    s736cf5613cb9d3a4: str `🇪🇸Invalid date format, please use ${0}`,
    s7bde484127940894: `🇪🇸Close icon`,
    s90e5e7cfe78db76a: str `🇪🇸Select a date up to ${0}`,
    s99cd035602574da9: `🇪🇸YYYY`,
    sa1f8e9fb7cc42cdd: `🇪🇸Make selection`,
    sb59d68ed12d46377: `🇪🇸Loading`,
    sbf78a48dfec1ed4e: `🇪🇸Info icon`,
    sc354fee3246340e1: str ` 🇪🇸 1 character too long`,
    sc60749e37db1dbc2: `🇪🇸Error icon`,
    scd105819b5a10243: `🇪🇸Play`,
    sd436a96b2169df50: `🇪🇸Check icon`,
    sdd90e9b409cd8863: str `🇪🇸Please select one of these options.`,
    sddaeebd037bba1f3: `🇪🇸carousel`,
    se6ee7403f29842c9: `🇪🇸Success check icon`,
    sf06255235cd23f2c: `🇪🇸Next button`,
    sf7d2f66db39fcc6a: `🇪🇸Alert icon`,
    sfabffb0a4f5ed03b: str `🇪🇸Please select toggle.`,
};
//# sourceMappingURL=es.js.map